module.exports = __webpack_public_path__ + "img/glamping_5.a1d86712.jpg";